import { Row, Col } from "antd";
import image from "../../images/maintenance.svg";
import { ContactUs } from "../../components/ContactUs";
import { useSelector } from "react-redux";
import "../NotFound/styles.scss";

export const Maintenance = () => {
  const metaData = useSelector((state: any) => state.metaData);

  return (
    <div className="h-100">
      <Row className="flex-column justify-center h-100 error-page">
        <Row>
          <Col className="error-page-left__container maintenance">
            <h1 className="header h h1 pb-9">
              Temporarily down for maintenance.
            </h1>
            <div className="pt-9 pb-9">
              <div className="text">Error code: 503.</div>
              <div className="text pt-6">
                We are performing scheduled maintenance to improve the
                service.We should be back online shortly.
              </div>
            </div>
            <h4 className="pt-9 pb-8 h h4">What to do?</h4>
            <div className="text pb-5">You might try again later.</div>
            {metaData && metaData.companySupportEmail && (
              <div className="text pb-9">
                Or if you need immediate help,{" "}
                <ContactUs href={`mailto:${metaData.companySupportEmail}`} />.
              </div>
            )}
            <div className="text pt-9">Thanks for your patience!</div>
          </Col>
          <Col className="error-img">
            <img src={image} alt="mainntenance" />
          </Col>
        </Row>
      </Row>
    </div>
  );
};
